// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-nocheck
declare module 'process.env' {}

import processEnv from 'process.env'

export function env(name: string, defaultValue?: string) {
  const dynamicEnvValue = window.ENV && window.ENV[name] // This is loaded from /public/env.js
  const staticEnvValue = processEnv[name] // This one is static & will be generated during compile time
  const value = dynamicEnvValue !== undefined ? dynamicEnvValue : staticEnvValue
  return value !== undefined ? value : defaultValue
}

export function envInt(name: string, defaultValue: number) {
  const value = env(name)
  return value !== undefined ? parseInt(value) : defaultValue
}

export function envFloat(name: string, defaultValue: number) {
  const value = env(name)
  return value !== undefined ? parseFloat(value) : defaultValue
}

export function envBoolean(name: string, defaultValue: boolean) {
  const value = env(name)
  return value !== undefined
    ? ['1', 'true'].includes(value.toLowerCase())
    : defaultValue
}

export function envJson(name: string, defaultValue?: any) {
  const value = env(name)
  return value !== undefined ? JSON.parse(value) : defaultValue
}
